import testFnc from "./components/test";

testFnc();


import {mask} from '../js/components/mask';

mask();


import accordion from './components/accordion';

accordion();


import marquee from './components/marquee';

marquee();

import form from './components/form';

form();


